import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { HeroComponent } from './components/hero/hero.component';
import { AboutComponent } from './components/about/about.component';
import { ExperienceComponent } from './components/experience/experience.component';
import { EducationComponent } from './components/education/education.component';
import { ProjectsComponent } from './components/projects/projects.component';
import { SkillsComponent } from './components/skills/skills.component';
import { ContactComponent } from './components/contact/contact.component';
import { FooterComponent } from './components/footer/footer.component';
import { portfolioData } from './portfolio.data';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    HeroComponent,
    AboutComponent,
    ExperienceComponent,
    ProjectsComponent,
    EducationComponent,
    SkillsComponent,
    ContactComponent,
    FooterComponent
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  data = portfolioData;
  isDark = true;
  showBackToTop = false;

  readonly navItems = [
    { id: 'about', label: 'À propos' },
    { id: 'experiences', label: 'Expériences' },
    { id: 'projects', label: 'Projet' },
    { id: 'education', label: 'Diplômes' },
    { id: 'skills', label: 'Compétences' },
    { id: 'contact', label: 'Contact' }
  ];

  constructor(private readonly themeService: ThemeService) {}

  ngOnInit(): void {
    const preferred = this.themeService.getPreferredTheme();
    this.isDark = preferred === 'dark';
    this.themeService.setTheme(preferred);
  }

  toggleTheme(): void {
    const next = this.themeService.toggleTheme(this.isDark ? 'dark' : 'light');
    this.isDark = next === 'dark';
  }

  @HostListener('window:scroll')
  onScroll(): void {
    this.showBackToTop = window.scrollY > 600;
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
